//Menu ----------------------------------------------------------------
(function () {
	'use strict';
	const masthead = getHeaderProps();

	function toggleMenu() {
		/* toggle mobile menu */
		//document.body.classList.remove('lockscroll');
		document.documentElement.classList.remove('lockscroll');

		const masthead = document.getElementById('masthead');
		masthead.classList.toggle('expanded');

		const navIcon = document.getElementById('js-nav-icon');
		navIcon.setAttribute('aria-expanded', 'false');
		navIcon.setAttribute('aria-pressed', 'false');

		const navClose = document.querySelector('#masthead button.close-menu');
		navClose.removeEventListener('click', toggleMenu);

		/* when mobile nav is opened, close nav by clicking anywhere else */
		if (masthead.classList.contains('expanded')) {
			//document.body.classList.add('lockscroll');
			document.documentElement.classList.add('lockscroll');
			navIcon.setAttribute('aria-expanded', 'true');
			navIcon.setAttribute('aria-pressed', 'true');
			navClose.addEventListener('click', toggleMenu);
		}
	}

	document.getElementById('js-nav-icon').addEventListener('click', toggleMenu);
	if (document.querySelector('button.js-toggle-mobile-menu'))
		document.querySelector('button.js-toggle-mobile-menu').addEventListener('click', toggleMenu);

	function stickyHeader(scrollUp) {
		//if (document.body.classList.contains('home')) return;

		//console.log(window.pageYOffset, masthead.height)

		if (scrollUp && window.pageYOffset < masthead.height / 2) {
			/* because of throttle we don't always get zero, so lets allow tolerance */
			masthead.obj.classList.remove('sticky');
		} else if (window.pageYOffset > 1) {
			masthead.obj.classList.add('sticky');
		} else {
			masthead.obj.classList.remove('sticky');
		}

		if (window.pageYOffset > masthead.height) {
			masthead.obj.classList.add('collapse');
		} else {
			masthead.obj.classList.remove('collapse');
		}
	}

	function scrollEventThrottle(fn) {
		let last_known_scroll_position = 0;
		let ticking = false;
		window.addEventListener('scroll', function () {
			let previous_known_scroll_position = last_known_scroll_position;
			last_known_scroll_position = window.scrollY;
			if (!ticking) {
				window.requestAnimationFrame(function () {
					fn(last_known_scroll_position, previous_known_scroll_position);
					ticking = false;
				});
				ticking = true;
			}
		});
	}

	function getHeaderProps() {
		let header = [];
		header.obj = document.getElementById('masthead');
		header.height = header.obj.offsetHeight;
		return header;
	}

	function simian_on_load() {
		// ## function invocation
		scrollEventThrottle((scrollPos, previousScrollPos) => {
			if (previousScrollPos > scrollPos) {
				//console.log("going up");
				stickyHeader(true);
			} else {
				//console.log("going down");
				stickyHeader();
			}
		});

		encryptEmailLinks();
	}

	window.addEventListener
		? window.addEventListener('load', simian_on_load, false)
		: window.attachEvent && window.attachEvent('onload', simian_on_load);

	function encryptEmailLinks() {
		const emailLinks = document.querySelectorAll('[data-email]');
		if (!emailLinks || emailLinks.length === 0) return;
		emailLinks.forEach((element) => {
			/* use the hostname for email domain */
			const match = /(?<=\.).+/.exec(location.hostname);
			const domain = match ? match[0] : location.hostname; // fallback
			const email = element.getAttribute('data-email') + '@' + domain;
			const subject = element.getAttribute('data-subject');
			element.href = 'mailto:' + email;
			if (subject) element.href += '?subject=' + subject;
			/* don't change innerText on btns */
			if (element.classList.contains('btn') == false) element.innerText = email;
		});
	}
})();
